import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { AuthenticationService } from './_shared/_services/authentication.service';
import { UsersService } from './_shared/_services/users.service';
import { locale, loadMessages } from 'devextreme/localization';
import frMessages from 'devextreme/localization/messages/fr.json';
import * as _ from 'underscore';
import { GlobalHelper } from './_shared/_helpers/global.helper';
import { SettingService } from './_shared/_services/setting.service';

import { alert } from 'devextreme/ui/dialog';
import { LoadingService } from './_shared/_services/loading.service';
import { DashCodeHelper } from './_shared/_helpers/dashcode.helper';
import { initFlowbite } from 'flowbite';
import { ScrollService } from './_shared/_services/scroll-service.service';
import { ViewportScroller } from '@angular/common';
import { ModalService } from './_shared/_services/modal-service.service';
import { ConnectionService } from './_shared/services/connection-service';
import { AssetLoaderService } from './_shared/services/asset-loader.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'evenement cllaj martinique';
  activeLayout;
  currentUser;
  subscriptions: any = [];
  // canContinue = false;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
    private settingService:SettingService,
    private route: ActivatedRoute,
    private globalHelper: GlobalHelper,
    public loadingService:LoadingService,
    private dashCodeHelper: DashCodeHelper,
    private scrollService: ScrollService,
    public modalService: ModalService,
    private connectionService: ConnectionService,
    private assetLoaderService: AssetLoaderService,
  ) {
    loadMessages(frMessages);
    if (typeof navigator != 'undefined') locale(navigator.language);
    // if(environment.env != 'extranet')
    //   this.router.navigate(['/piecesatelier']);
    // this.usersService.chargeItems()


    this.subscriptions.push(
      this.authenticationService.currentUser.subscribe(async (x) => {
        this.currentUser = x;
        // alert("user " + x.nom)
      })
    );
    this.route.queryParams.subscribe(params => {
      const serializedData = params['cllaj_messages'];
      // Vérifiez si des données sont présentes dans l'URL
      if (serializedData) {
        // Désérialisez les données
        const dataArray = this.deserializeData(serializedData);
        // Utilisez dataArray comme nécessaire
        console.log(dataArray);
        // devextreme alert
        if(dataArray.erreur)
        alert(dataArray.erreur,'Une erreur est survenue')
        else if(dataArray.message)
        alert(dataArray.message,dataArray.message_title)

      }
    });

    router.events.subscribe(async (val) => {
      // console.log('router events',val);
      // console.log('NavigationEndsss',router.url);
      // see also
      if (val instanceof NavigationEnd) {
        initFlowbite();
        this.globalHelper.updateMetaTags(
          {title: 'CLLAJ Martinique D\'Clic Jeune',
          description:`Des Informations - des Services - des Locations - des Aides -
          un Accès aux droits - à l'Autonomie - un Réseau de professionnels`,
        url:window?.location.href})
        // && this.currentUser
        if(val.url.indexOf('auth') == -1  && (environment.adminOnly || val.url.indexOf('dashboard')> -1)){
          this.activeLayout = 'dashlayout';
        }
        else if(val.url.indexOf('auth') == -1  &&  val.url.indexOf('forum')> -1){
          this.activeLayout = 'forum';
        }
        else if(val.url.indexOf('auth') == -1 ){
          this.activeLayout = 'layout';
        }
        else this.activeLayout = 'authlayout';

        // if (environment.env == 'production') {
          // if has setting maintenanceMode and is true
          if(_.find(this.settingService.items, i => i.setting == "comingSoonMode" && i.value == 1)){

            if (router.url != '/comingsoon') {
              this.router.navigate(['/comingsoon']);
            }

          }
          else if(_.find(this.settingService.items, i => i.setting == "maintenanceMode" && i.value == 1)){

            if (router.url != '/maintenance') {
              this.router.navigate(['/comingmaintenancesoon']);
            }

          }
          else  if (router.url == '/comingsoon') {
              this.router.navigate(['/']);
          }
        // }
        if (router.url == '/') {
          // if (
          //   this.globalHelper.hasRoles(['ADMIN_MAGASIN','USER_MAGASIN']) && !this.currentUser.admin
          // ) {
          //   this.router.navigate(['/commandes']);
          // }
          // if (
          //   this.globalHelper.hasRoles(['ADMIN_ATELIER','USER_ATELIER']) && !this.currentUser.admin
          // ) {
          //   this.router.navigate(['/piecesatelier']);
          // }
          //,'CLIENT_PRO','CLIENT_PARTICULIER' => home
        }

      if (typeof window != "undefined" && window.navigator.userAgent != "fakeAgent") {
        if (window.location.hash.substr(1)) {
          // setTimeout(() => {
          // window.scrollTo(
          //   0,
          //   document.getElementById(window.location.hash.substr(1))
          //     .offsetTop
          // );

          // console.log(
          //   'scroll to ' +
          //     document.getElementById(window.location.hash.substr(1)).offsetTop
          // );
          // }, 1000);
          // console.log("scroll to element");
        } else {
          // window.scrollTo(0, 0);
          // console.log("scroll to 0");
        }
        // _paq.push([
        //   "setCustomUrl", window.location.pathname + window.location.hash
        // ]);
        // _paq.push(["trackPageView"]);
      }
      }
    });
  }
  private deserializeData(serializedData: string): any {
    // Exemple : Si vous avez utilisé http_build_query, vous pouvez utiliser le parseur URLSearchParams
    const urlSearchParams = new URLSearchParams(serializedData);
    const obj: any = {};
    urlSearchParams.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  }
  async ngOnInit(): Promise<void> {
    // Initialiser les services d'optimisation pour les connexions lentes
    this.connectionService.initConnectionMonitoring();
    this.assetLoaderService.initializeAssetLoading();

    initFlowbite();

    this.globalHelper.checkCookiesIsAccepted()
    // if (environment.env == 'production')
    // this.router.navigate(['/comingsoon']);

    this.settingService.chargeItems().then(res=>{

      if(this.settingService.items?.length && _.find(this.settingService.items, i => i.setting == "comingSoonMode" && i.value == 1)){

        if (this.router.url != '/comingsoon') {
          console.log('redireccct to cocmingsoon')
          this.router.navigate(['/comingsoon']);
        }

      }
      else if(this.settingService.items?.length && _.find(this.settingService.items, i => i.setting == "maintenanceMode" && i.value == 1)){

        if (this.router.url != '/maintenance') {
          this.router.navigate(['/comingmaintenancesoon']);
        }

      }

    })



    this.loadScript();
    // if(!this.settingService.items?.length)
    // await this.settingService.chargeItems()
    // if has setting maintenanceMode and is true
    // if(_.find(this.settingService.items, i => i.setting == "comingSoonMode" && i.value == 1)){
        // this.router.navigate(['/comingsoon']);

    // }
    // else if(_.find(this.settingService.items, i => i.setting == "maintenanceMode" && i.value == 1)){
    //     this.router.navigate(['/comingmaintenancesoon']);

    // }
  }
  loadScript() {

    if (environment.env == 'production') {
         let node = document.createElement('script'); // creates the script tag
    node.src = 'https://www.googletagmanager.com/gtag/js?id=G-8YVTE3T40J'; // sets the source (insert url in between quotes)
    node.type = 'text/javascript'; // set the script type
    node.async = true; // makes script run asynchronously
    // append to head of document
    document.getElementsByTagName('head')[0].appendChild(node);
  //   alert('moli')
  }
}
// @HostListener('window:resize', ['$event']) // for window scroll events
// onresize($event) {
//   this.dashCodeHelper.handleResize();
// }



// @HostListener('document:focus', ['$event'])
// onFocus(event: FocusEvent): void {
//   // Your logic when document receives focus
//   console.log('Document focused');
//   this.globalHelper.scanReady = true;
// }

// @HostListener('document:blur', ['$event'])
// onBlur(event: FocusEvent): void {
//   console.log('Document blurred');
//   // Your logic when document loses focus
//   this.globalHelper.scanReady = false;
// }

}
